import { AppStorageKeys } from "./Constants";

class SessionStorage {
  static get = (key) => {
    try {
      return JSON.parse(sessionStorage.getItem(key));
    } catch (error) {
      switch (key) {
        case AppStorageKeys.currentUser:
          return {};
        case AppStorageKeys.appEnv:
          return "";
        default:
          return {};
      }
    }
  };

  static set = (key, value) => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.log("Error setting session storage:", key);
    }
  };

  static remove = (key) => {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.log("Error removing session storage:", key);
    }
  };
}

export default SessionStorage;
